import { ClassValue, tv, type VariantProps } from "tailwind-variants";
import { SlotsToClasses } from "@nextui-org/theme";
import { clamp } from "@networx/utils/math/clamp";

export default function ProgressBar({
  label,
  className, classNames,
  value,
  ...tvProps
}: Props) {
  value ??= 0;
  value = clamp(value, 0, 100);
  const style = progressBar(tvProps);
  return (
    <div
      className={style.base({ className: [className, classNames?.base] })}
    >
      <div className={style.wrapper({ className: classNames?.wrapper })}>
        <div
          style={{ transform: `translate(-${100 - value}%)` }}
          className={style.progress({ className: classNames?.progress })} />
      </div>
      <p className={style.label({ className: classNames?.label })}>{label ? label(value) : `${value}%`}</p>
    </div>
  );
}

const progressBar = tv({
  slots: {
    base: ["flex-1 flex justify-center items-center gap-2"],
    wrapper: ["relative h-5 flex-1 rounded-full overflow-hidden bg-default-200"],
    progress: ["w-full h-full bg-green-500 rounded-full", "transition-transform duration-500"],
    label: ["text-content1 text-sm font-semibold"],
  },
  variants: {
  },
  defaultVariants: {
  },
});

export type ProgressBarProps = VariantProps<typeof progressBar>;

interface Props extends ProgressBarProps {
  label?: (progress: number) => React.ReactNode;
  value?: number;
  className?: ClassValue;
  classNames?: SlotsToClasses<keyof ReturnType<typeof progressBar>>;
}
